import { render, staticRenderFns } from "./clienti.vue?vue&type=template&id=38d3069f&scoped=true&"
import script from "./clienti.vue?vue&type=script&lang=js&"
export * from "./clienti.vue?vue&type=script&lang=js&"
import style0 from "./clienti.vue?vue&type=style&index=0&id=38d3069f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3069f",
  null
  
)

export default component.exports